const { userAgent } = window.navigator;
const isExplorerAgent = userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0;

export default isExplorerAgent;
